import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RoutingService } from '../../../routing/routing.service';
import { LoginService } from '../../services/login.service';
import { LogoutService } from "@services/logout.service";

@Component({
    selector: 'logged-out-view',
    templateUrl: './logged-out-view.component.html',
    styleUrls: ['./logged-out-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoggedOutViewComponent {
    message = 'Session Expired. Please refresh the page.';

    constructor(
        private loginService: LoginService,
        private routingService: RoutingService,
        private logoutService: LogoutService,
    ) {
        if (this.loginService.isAuthenticated()) {
            this.routingService.navigateToDashboard();
        }
    }

    refresh(): void {
        if (this.loginService.isAuthenticatedSaml()) {
            this.logoutService.logoutSaml();
            return;
        }

        this.routingService.navigateToLogin();
    }
}
